var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Analytics = /** @class */ (function () {
    function Analytics() {
    }
    Analytics.prototype.Log = function (event, data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(__assign({ event: event }, data));
    };
    return Analytics;
}());
export default new Analytics();
